/** @file PoseScreen: node tree left, viewport over timeline in the centre, inspector right. */
import type { ReactElement } from 'react';
import { panelRegistry } from '../shell/panelRegistry';
import { useEditor } from '../state/useEditor';
import { SplitPane } from '../ui-kit/SplitPane';

/**
 * Mounts the panels from `panelRegistry`; every divider can be dragged. View > Node tree / Inspector / Timeline hide a
 * panel (`shell.panels`) by collapsing its pane: nothing unmounts, so the viewport keeps its engine.
 */
export function PoseScreen(): ReactElement {
  const panels = useEditor((s) => s.shell.panels);
  const { nodeTree: NodeTree, viewport: Viewport, timeline: Timeline, inspector: Inspector } = panelRegistry;
  return (
    <SplitPane direction="row" fixed="start" initial={240} label="Pose screen" collapsed={!panels.tree}>
      <div className="p3-panel" data-panel="nodeTree"><NodeTree /></div>
      <SplitPane direction="row" fixed="end" initial={300} collapsed={!panels.inspector}>
        <SplitPane direction="column" fixed="end" initial={220} min={120} max={600} collapsed={!panels.timeline}>
          <div className="p3-panel" data-panel="viewport"><Viewport mode="edit" /></div>
          <div className="p3-panel" data-panel="timeline"><Timeline /></div>
        </SplitPane>
        <div className="p3-panel" data-panel="inspector"><Inspector /></div>
      </SplitPane>
    </SplitPane>
  );
}
